import type { SxProps } from '@mui/material'
import { Chip, type ChipProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import type { StatusVariant } from '@/types/status.types.ts'
import { getStatusColors } from '@/utils/statusColors.ts'

interface StatusChipProps {
  label: string
  variant?: StatusVariant
  sx?: SxProps
  icon?: ChipProps['icon']
  onClick?: ChipProps['onClick']
}

const StyledChip = styled(Chip)<{ status: StatusVariant }>(({ theme, status }) => {
  const colors = getStatusColors(status, theme)

  return {
    backgroundColor: colors.backgroundColor,
    color: colors.color,
    textTransform: 'uppercase',
    fontFamily: 'Geist Mono, monospace',
    fontWeight: 600,
    height: 'auto',
    borderRadius: theme.shape.borderRadius,
    '& .MuiChip-label': {
      padding: theme.spacing(0.4, 1),
      whiteSpace: 'nowrap',
      textAlign: 'center',
      display: 'block'
    }
  }
})

export function StatusChip({
  label,
  variant = 'default',
  sx,
  icon,
  onClick
}: StatusChipProps) {
  return (
    <StyledChip label={label} status={variant} sx={sx} icon={icon} onClick={onClick} />
  )
}
